import { Article, ArticleType } from '@wix/answers-api';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { FunctionComponent, useMemo } from 'react';
import { DATA_HOOKS } from '../../../../dataHooks';
import { InnerLink } from '../../../InnerLink';
import { ArticleMediumIcon } from '../../../../icons/ArticleMediumIcon';
import css from './index.module.scss';

export type ArticleListSectionProps = {
  articles: Article[];
  type: ArticleType;
};

export const ArticleListSection: FunctionComponent<ArticleListSectionProps> = ({
  articles,
  type,
}) => {
  const { t } = useTranslation();
  const getArticleTypeTitle = useMemo((): string => {
    switch (type) {
      case ArticleType.KNOWN_ISSUE:
        return t('category.articles.type.known.issue');
      case ArticleType.FEATURE_REQUEST:
        return t('category.articles.type.feature.requests');
      default:
        return t('category.articles.type.articles');
    }
  }, [type, t]);

  return (
    <>
      {articles.length > 0 && (
        <Box
          direction="vertical"
          className={css.articles}
          dataHook={DATA_HOOKS.CATEGORY_ARTICLES_SECTION}
        >
          <Text
            className={css.articleType}
            dataHook={DATA_HOOKS.CATEGORY_ARTICLES_SECTION_TYPE}
          >
            {getArticleTypeTitle}
          </Text>
          <Box direction="vertical" className={css.articleLinks}>
            {articles.map((article) => (
              <InnerLink
                withEnterHandler
                href={article.uri}
                className={css.articleLink}
                dataHook={DATA_HOOKS.CATEGORY_ARTICLES_SECTION_LINK}
                key={article.id}
              >
                <Box gap="5px" verticalAlign="top">
                  <ArticleMediumIcon />
                  <Text
                    size="medium"
                    maxLines={2}
                    ellipsis
                    className={css.articleTitle}
                  >
                    {article.title}
                  </Text>
                </Box>
              </InnerLink>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};
